import { GET_HAS_ABN, SHOW_ERROR, SUBMIT_ABN } from '.'
import * as api from '../api/abn'
import { trackBackgroundCheckSteps } from '../events'
import * as DA from '../typeModules/events'

/**
 * @param {string} australianBusinessNumber - ABN for AU tax requirements
 */
export const submitAbnRequest = (australianBusinessNumber: string) => {
  return async dispatch => {
    try {
      dispatch({ type: SUBMIT_ABN.IN_PROGRESS })

      const response = await api.submitAbn({
        australianBusinessNumber,
        // gst default to false
        isGstRegistered: false,
      })

      dispatch(
        trackBackgroundCheckSteps({
          page: DA.BackgroundCheckPages.ABN,
          action: DA.EventActions.Success,
          value: 'submit-abn',
        })
      )

      dispatch({
        type: SUBMIT_ABN.SUCCESS,
        payload: response,
      })
    } catch (error) {
      if (error.status === 409) {
        // if ABN already exists, pass through
        return
      }

      dispatch({ type: SUBMIT_ABN.FAIL, payload: error.message })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackBackgroundCheckSteps({
          page: DA.BackgroundCheckPages.ABN,
          action: DA.EventActions.Error,
          value: `submit-abn: ${error.message}`,
        })
      )
      throw error
    }
  }
}

export const getHasAbnRequest = () => {
  return async dispatch => {
    try {
      dispatch({ type: GET_HAS_ABN.IN_PROGRESS })

      const response = await api.getHasAbn()
      dispatch(
        trackBackgroundCheckSteps({
          page: DA.BackgroundCheckPages.ABN,
          action: DA.EventActions.Success,
          value: 'get-abn',
        })
      )
      dispatch({
        type: GET_HAS_ABN.SUCCESS,
        payload: response,
      })
    } catch (error) {
      dispatch({ type: GET_HAS_ABN.FAIL, payload: error.message })
      dispatch({ error, type: SHOW_ERROR })
      dispatch(
        trackBackgroundCheckSteps({
          page: DA.BackgroundCheckPages.ABN,
          action: DA.EventActions.Error,
          value: `get-abn: ${error.message}`,
        })
      )
    }
  }
}
